import loader from '@monaco-editor/loader';
import * as monaco from 'monaco-editor';
import Loadable from 'react-loadable';

import getMonacoWorker from '../utils/get-monaco-worker';

import FileLoading from './file-loading';

/**
 * Once upon a time, the Loadable code below was enough to bundle Monaco. It created a split bundle
 * that lazily-loaded both the wrapper (react-monaco-editor) and the core library (monaco-editor) only on
 * Source pages.
 *
 * We've made a lot of changes since then, including moving from Webpack to Parcel to Atlaspack, and also
 * upgrading react-monaco-editor from a very old version to close to the latest. At some point in that
 * journey, importing `monaco` directly from monaco-editor and using this loader became important. Without this,
 * syntax highlighting no longer works (and possibly other things).
 */
loader.config({ monaco });

export default Loadable({
  loader: () => {
    const loadEditor = import(
      /* webpackChunkName: "react-monaco-editor" */ 'react-monaco-editor'
    );

    loadEditor.then(() => {
      /**
       * This code must run after the monaco module code has been evaluated/imported, not before
       *
       * see: get-monaco-worker.parcel.ts for more context re: why we define our own web worker
       * import logic
       */
      window.MonacoEnvironment = {
        getWorker: (_, label) => getMonacoWorker(label),
      };
    });

    return loadEditor;
  },
  loading: () => <FileLoading />,
  render(loaded, props) {
    const ReactMonacoEditor = loaded.default;

    return <ReactMonacoEditor {...props} />;
  },
});
